import React from 'react';
import AnimatedCard from '@/components/ui/AnimatedCard';
import { ArrowRight } from 'lucide-react';

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
  link: string;
}

const ServiceCard = ({ 
  icon, 
  title, 
  description, 
  delay = 0,
  link
}: ServiceCardProps) => {
  return (
    <AnimatedCard 
      className="h-full flex flex-col group hover:shadow-xl transition-all duration-300"
      animationDelay={delay}
    >
      <div className="relative overflow-hidden rounded-xl bg-white/80 backdrop-blur-sm border border-white/20">
        <div className="p-4">
          <div className="mb-4">
            <div className="w-10 h-10 rounded-lg bg-orcsys-50/80 flex items-center justify-center mb-2">
              <div className="w-6 h-6 text-orcsys-500">
                {icon}
              </div>
            </div>
            <h3 className="text-base font-semibold text-slate-900 mb-1.5">{title}</h3>
            <p className="text-slate-600 leading-relaxed text-sm">{description}</p>
          </div>
          <a href={link} className="inline-flex items-center text-orcsys-500 hover:text-orcsys-600 font-medium group/link text-sm">
            En savoir plus
            <ArrowRight size={14} className="ml-1.5 transition-transform group-hover/link:translate-x-1" />
          </a>
        </div>
      </div>
    </AnimatedCard>
  );
};

export default ServiceCard; 